import { forwardRef, memo } from 'react';
import { GoMotoComponent } from '../../../API/GoMoto.types';
import Grid, { Grid2Props } from '@mui/material/Unstable_Grid2';

/**
 * The MUI Grid2 base control. This control exists exclusively
 * to mock for unit testing.
 *
 * @props {@link Grid2Props}.
 */
export const BaseGrid: GoMotoComponent<Grid2Props> = memo(forwardRef(({
    children,
    ...props
}, ref) => {
    return (
        <Grid ref={ref} {...props}>
            {children}
        </Grid>
    );
}));